import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const ServiceHeader = ({ 
  searchTerm, 
  onSearchChange, 
  onAddService, 
  totalServices,
  activeServices 
}) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1 mb-6">
      {/* Header Title and Stats */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
        <div className="mb-4 lg:mb-0">
          <h1 className="text-2xl font-bold text-foreground mb-2">
            Service Management
          </h1>
          <div className="flex items-center space-x-6 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="Package" size={16} />
              <span>{totalServices} Total Services</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="status-indicator active"></div>
              <span>{activeServices} Active</span>
            </div>
            {/* <div className="flex items-center space-x-2">
              <Icon name="Calendar" size={16} />
              <span>Last updated: {new Date()?.toLocaleDateString()}</span>
            </div> */}
          </div>
        </div>

        {/* Add Service Button */}
        <Button
          onClick={onAddService}
          iconName="Plus"
          iconPosition="left"
          iconSize={16}
          className="w-full lg:w-auto"
        >
          Add New Service
        </Button>
      </div>
      {/* Search and Actions */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0 md:space-x-4">
        {/* Search Input */}
        <div className="flex-1 max-w-md">
          <div className="relative">
            <Icon 
              name="Search" 
              size={16} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" 
            />
            <input
              type="text"
              placeholder="Search services by name or category..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
            />
            {searchTerm && (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onSearchChange('')}
                className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6"
              >
                <Icon name="X" size={14} />
              </Button>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        {/* <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            iconSize={14}
          >
            Export
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Upload"
            iconPosition="left"
            iconSize={14}
          >
            Import
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Settings"
            iconPosition="left"
            iconSize={14}
          >
            Settings
          </Button>
        </div> */}
      </div>
      {/* Quick Stats Cards */}
      {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="DollarSign" size={16} className="text-success" />
            <span className="text-sm font-medium text-foreground">Revenue</span>
          </div>
          <div className="text-xl font-bold text-success">$12,450</div>
          <div className="text-xs text-muted-foreground">This month</div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="TrendingUp" size={16} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Popular</span>
          </div>
          <div className="text-xl font-bold text-primary">8</div>
          <div className="text-xs text-muted-foreground">High demand</div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Clock" size={16} className="text-warning" />
            <span className="text-sm font-medium text-foreground">Avg. Time</span>
          </div>
          <div className="text-xl font-bold text-warning">45m</div>
          <div className="text-xs text-muted-foreground">Per service</div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Star" size={16} className="text-accent" />
            <span className="text-sm font-medium text-foreground">Rating</span>
          </div>
          <div className="text-xl font-bold text-accent">4.8</div>
          <div className="text-xs text-muted-foreground">Average</div>
        </div>
      </div> */}
    </div>
  );
};

export default ServiceHeader;